import { createFileRoute } from '@tanstack/react-router';
import { IdentityProvidersPage } from '../../features/settings/components/identity-providers-page.js';

export const Route = createFileRoute('/admin/identity-providers')({
  component: IdentityProvidersPage,
});
